export default "__VITE_ASSET__2706d8fc__"